import axios from 'axios';

import config from '@/config/config';
import { headers } from './auth.headers';
import { formatQueryString } from '@/helpers/query-string';
import { IEconomicSector } from '@/domain/economic-sector.model';
import { IPaginateVueTable } from '@/interfaces/IPaginateVueTable';

const url_api_base = config.url_api_cliente;

export const insert = (data: IEconomicSector): Promise<IEconomicSector> => {
  return axios.post(`${url_api_base}/economic-sector`, data, headers());
};

export const update = (data: IEconomicSector): Promise<IEconomicSector> => {
  return axios.patch(`${url_api_base}/economic-sector/${data.id}`, data, headers());
};

export const get = (id: string): Promise<IEconomicSector> => {
  const url = `${url_api_base}/economic-sector/${id}`;

  return axios.get(url, headers()).then((res) => res?.data);
};

export const list = (
  offset?: number,
  limit?: number,
  order?: string,
  sort?: string,
  filter?: string,
): Promise<IPaginateVueTable<IEconomicSector>> => {
  const query = formatQueryString(offset, limit, order, sort, filter);
  const url = `${url_api_base}/economic-sector${query}`;

  return axios.get(url, headers()).then((res) => res?.data);
};
